import { render } from "./PopoverContainer.vue?vue&type=template&id=e357ffa8&scoped=true&lang=pug"
import script from "./PopoverContainer.vue?vue&type=script&lang=js"
export * from "./PopoverContainer.vue?vue&type=script&lang=js"

import "./PopoverContainer.vue?vue&type=style&index=0&id=e357ffa8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e357ffa8"]])

export default __exports__